import ServiceBus from "servicestack/service-bus";
import basicController from "servicestack/basic.controller.properties";
import AutoQuery from "servicestack/auto-query/auto-query";
import labels from "emun.order/_labels";

export default class PartsOrderPromptController {
  constructor(options) {
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.bus = new ServiceBus();
    $ctrl.title = options.title || "Parts Order";
    $ctrl.labels = labels;
    $ctrl.product = options.product;
    $ctrl.order = {
      productId: $ctrl.product.id,
      retailer: {}
    };
    $ctrl.results = [];
    $ctrl.parts = JSON.parse($ctrl.product.meta.Parts);
  }

  qty() {
    const $ctrl = this;
    return $ctrl.results.reduce((sum, { qty }) => sum + qty, 0);
  }

  save() {
    const $ctrl = this;
    const url = `CreatePartsOrder.json`;
    $ctrl.order.lines = [];
    $ctrl.results.forEach(function(part) {
      if (part.qty > 0) {
        $ctrl.order.lines.push({
          productId: part.id,
          quantity: part.qty,
          reason: part.reason,
          comments: part.comment
        });
      }
    });
    $ctrl.bus.send(url, $ctrl.order).then(function(response) {
      $ctrl.$close(response.data);
      $ctrl.$emit("partsOrderSaved", $ctrl);
    });
  }
}
